import "@alchemy_cms/admin"
import "../../alchemy_admin/js/reservationType";
import copyToClipboard from "../../alchemy_admin/js/utils/copyToClipboard";
import { Italian } from "flatpickr/dist/l10n/it.js"

window.copyToClipboard = copyToClipboard

Alchemy.translations.en.formats = {
  datetime: "Y-m-d H:i",
  date: "Y-m-d",
  time: "H:i",
  time_24hr: true
}

flatpickr.localize(Italian); // default locale is now Italian
